module.exports = "app.service(\"Role\",[\"Resty\",function(Resty){return Resty(\"roles\",\"dictionaries\");}]);"